import React from 'react';
import YouTube from 'react-youtube';

class YouTubeComponent extends React.Component {
    render() {
        const opts = {
            // height: '390',
            // width: '640',
            playerVars: {
                // https://developers.google.com/youtube/player_parameters
                autoplay: 0,
                rel: 0, // only show related videos from the same channel
                color: 'white', // change the progress color of the player
                modestbranding: 1, // disable YouTube brand in the player
                hl: this.props.isEn ? 'en' : 'zh', // change the language of the player
                cc_load_policy: this.props.isEn ? 0 : 1, // whether to show captions
                cc_lang_pref: this.props.isEn ? 'en' : 'zh', // change the language of the caption
            },
        };

        return <YouTube videoId={this.props.youtubeId} opts={opts} onReady={this._onReady} />;
    }

    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
}

export default YouTubeComponent;